<div class="change-password-content">

  <div class="form-section">
    <div class="form-item">
      <div class="input-title">Old Password</div>
      <mat-form-field appearance="outline">
        <input matInput type="password" [(ngModel)]="currentPassword" id="password" name="old-password" placeholder="Old Password" (keyup)="checkValid()">
      </mat-form-field>
    </div>
  </div>

  @if (newPassword && verifiedPassword && newPassword !== verifiedPassword) {
    <div class="error-message">
      Passwords do not match.
    </div>
  }

  <div class="form-section">
    <div class="form-item">
      <div class="input-title">New Password</div>
      <mat-form-field appearance="outline">
        <input matInput type="password" [(ngModel)]="newPassword" id="password" name="new-password" placeholder="New Password" (keyup)="checkValid()">
      </mat-form-field>
    </div>
  </div>

  <div class="form-section">
    <div class="form-item">
      <div class="input-title">Verify Password</div>
      <mat-form-field appearance="outline">
        <input matInput type="password" [(ngModel)]="verifiedPassword" id="password" name="verify-password" placeholder="Verify Password"  (keyup)="checkValid()">
      </mat-form-field>
    </div>
  </div>
</div>
@if (loading) {
  <jhm-loading></jhm-loading>
}